import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource as dragSource } from 'react-dnd';
import DnDItemTypes from '../DynamicDnD/DnDItemTypes';

const dragItemsSource = {
  beginDrag(props) {
    return { selectedNode: props.node, useQuestions: props.useQuestions };
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

class DraggableNode extends Component {
  render() {
    const {
      connectDragSource,
      isDragging,
      baseStyle,
      titleStyle,
      iconClass,
      iconStyle,
      name,
    } = this.props;

    return connectDragSource(
      <div
        style={{
          opacity: isDragging ? 0.5 : 1,
          ...baseStyle,
        }}
      >
        <div style={titleStyle}>
          <span className={iconClass} style={iconStyle} />
          {name}
        </div>
      </div>,
    );
  }
}

DraggableNode.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  baseStyle: PropTypes.shape({}),
  titleStyle: PropTypes.shape({}),
  iconClass: PropTypes.string,
  iconStyle: PropTypes.shape({}),
  name: PropTypes.string.isRequired,
  node: PropTypes.shape({}),
};

export default dragSource(
  DnDItemTypes.DnD_ITEM_TYPE_1,
  dragItemsSource,
  collect,
)(DraggableNode);
